import React, { useEffect, useState, useRef } from "react";
import * as s from "../styles/globalStyles";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "../redux/blockchain/blockchainActions";
import { fetchData } from "../redux/data/dataActions";
import styled from "styled-components";
import { useFormik } from 'formik';

var Web3 = require('web3');
const { MerkleTree } = require('merkletreejs')
import { keccak256 } from "@ethersproject/keccak256";
const { ethers } = require("ethers");

const whitelisted = require('../whitelist.json');

export const SocialsFooterWrapper = styled.div`
  background-color: var(--accent2);
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  padding-top: 18px;
  padding-bottom: 18px;
  // position: absolute;
  bottom: 0;
`;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 6px;
  background-color: var(--accent3); 
  border: 2px solid var(--white);
  color: var(--white);
  padding: 10px;
  font-weight: bold;
  font-family: coder;
  cursor: pointer;
  :hover{
    border: 2px solid var(--white);
    background-color: var(--accent);
    color: var(--black);
  }
`;

export const StyledLink = styled.a`
  color: var(--accent);
  font-size: 10px;
  line-height: 1.6;
  text-decoration: none;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 10px;
    text-align: center;
  }
  @media (min-width: 1080px) {
    font-size: 14px;
  };
  :hover{
    color: var(--accent);
`;

export const StyledSocialLink = styled.a`
  color: var(--window);
  text-decoration: none;
  text-align: center;
  font-size: 10px;
  :hover{
    color:  var(--accent); 
`;

export const LinkSpacer = styled.a`
  color: var(--off-white);
  text-decoration: none;
  text-align: center;
  font-size: 8px;
  padding-right: 18px;
  padding-left: 18px;
  :hover{
    color:  var(--accent2); 
`;

export const SocialLink = styled.a`
  color: var(--off-white);
  font-size: 24px;
  text-decoration: none;
  text-align: center;
  :hover{
    color: var(--button-dark-blue); 
`;

const userIsWhitelisted = (userAddress) => {
  return whitelisted.includes(userAddress.toLowerCase())
};

const padBuffer = (addr) => {
  return Buffer.from(addr.substr(2).padStart(32*2, 0), 'hex')
}

function MintWindow({ secondsDiff, minutesDiff, hoursDiff, daysDiff, timerEnabled, timerType }) {
    const data = useSelector((state) => state.data);
    const blockchain = useSelector((state) => state.blockchain);
    const dispatch = useDispatch();
    const getData = () => {
        if (blockchain.account !== "" && blockchain.smartContract !== null) {
          dispatch(fetchData(blockchain.account));
        }
      };
    let [feedbackTextColour, setFeedbackTextColour] = useState('');
    const [feedback, setFeedback] = useState('');
    const [contributing, setContributing] = useState(false);
    const [contributionTxHash, setContributionTxHash] = useState(null);
    const [contributingSuccessful, setContributingSuccessful] = useState(false);
    const [refundSuccessful, setRefundSuccessful] = useState(false);
    const [refundTxHash, setRefundTxHash] = useState(null);
    const [refunding, setRefunding] = useState(false);

    const [claimSuccessful, setClaimSuccessful] = useState(false);
    const [claimTxHash, setClaimTxHash] = useState(null);
    const [claiming, setClaiming] = useState(false);

    const checkMax = contribution => {
      let val = parseFloat(contribution);
      let asWei = Web3.utils.toWei(val.toString(), 'ether')
      return asWei <= CONFIG.MAXIMUM_PRESALE
    }

    const checkMin = contribution => {
      let val = parseFloat(contribution);
      let asWei = Web3.utils.toWei(val.toString(), 'ether')
      return asWei >= CONFIG.MINIMUM_PRESALE
    }

    const checkExceeds = contribution => {
      let contributedVal = parseFloat(contribution);
      let contrbutingVal = parseFloat(data.contribution);
      return contributedVal + contrbutingVal <= Web3.utils.fromWei(String(CONFIG.MAXIMUM_PRESALE), 'ether')
    }

    const checkExceedsHardcap = contribution => {
      let contributedVal = parseFloat(contribution);
      let ethRaisedVal =  parseFloat(Web3.utils.fromWei(String(data.raised), 'ether'))
      return contributedVal + ethRaisedVal <= Web3.utils.fromWei(String(data.pool.hardCap), 'ether')
    }


    const checkFormat = contribution => {
      if (!new RegExp('^[0-9\.]*$').test(contribution)) {
        return false
      }

      let val = parseFloat(contribution);
      return !isNaN(val);
    }

    const validate = values => {
      const errors = {};
      if (!values.contribution) {
        errors.contribution = 'Required';
      } else if (!checkFormat(values.contribution)) {
        errors.contribution = 'Invalid eth amount';
      } else if (!checkMin(values.contribution)) {
        errors.contribution = 'Contribution too small';
      } else if (!checkMax(values.contribution)) {
        errors.contribution = 'Contribution too large';
      } else if (!checkExceeds(values.contribution)) {
        errors.contribution = 'Exceeds max buy limit';
      } else if (!checkExceedsHardcap(values.contribution)) {
        errors.contribution = 'Exceeds hard cap';
      }
      return errors;
    };

    const formik = useFormik({
      initialValues: {
        contribution: '',
      },
      validate,
    });

    const ContributeForm = () => {
      return (
        <form onSubmit={formik.handleSubmit}>
          <input
            id="contribution"
            name="contribution"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.contribution}
            autoFocus
          />

          <div>
          <StyledButton onClick={(e) => {
                e.preventDefault();
                contribute(formik.values.contribution, formik.errors.contribution);
            }}>
            CONTRIBUTE
          </StyledButton>
          </div>
        </form>
      );
    }

    const ShowRefund = () => {
      return (
          <StyledButton onClick={(e) => {
                e.preventDefault();
                refund();
            }}>
            REFUND
          </StyledButton>
      );
    };

    const ShowClaim = () => {
      if (data.claimRound == 0){
        setFeedbackTextColour('accent')
        setFeedback("Claims not open yet.")
        ShowFeedback()
        return null
      }
      if (data.claimRound == 1 && data.claims.claimedRoundOne){
        setFeedbackTextColour('accent')
        setFeedback("Round 1 already claimed.")
        ShowFeedback()
        return null
      } else if (data.claimRound == 2 && data.claims.claimedRoundTwo){
        setFeedbackTextColour('accent')
        setFeedback("Round 2 already claimed.")
        ShowFeedback()
        return null
      } else if (data.claimRound == 3 && data.claims.claimedRoundThree){
        setFeedbackTextColour('accent')
        setFeedback("Round 3 already claimed.")
        ShowFeedback()
        return null
      }

      return (
          <StyledButton onClick={(e) => {
                e.preventDefault();
                claim();
            }}>
            CLAIM
          </StyledButton>
      );
    };

    const TimerElement = (count, interval) => {
      return (
        <s.Container ai="center">
        <s.TextSubTitle style={{ fontSize: "16px", color: "var(--accent)" }}>
          {count}
        </s.TextSubTitle>
        <s.TextSubTitle style={{ fontSize: "8px" }}>
          {interval}
        </s.TextSubTitle>
        </s.Container>
      );
    };

    const contribute = async (contribution, validationErrors) => {
      setContributingSuccessful(false);

      if (contribution == "") {
        setFeedbackTextColour('accent')
        setFeedback("Please provide an amount")
        ShowFeedback()
        return
      }

      if (validationErrors != null){
        setFeedbackTextColour('accent')
        setFeedback(validationErrors)
        ShowFeedback()
        return
      }

      let gasLimit = CONFIG.GAS_LIMIT;
      let totalGasLimit = gasLimit;

      setFeedbackTextColour('accent');
      setFeedback(`Contributing ${contribution} ETH`, false);
      setContributing(true);
      setContributingSuccessful(false);

      let txData = {
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: Web3.utils.toWei(contribution.toString(), 'ether')
      }

      if (data.state == 1){
        const leaves = whitelisted.map(account => padBuffer(account))
        let tree = new MerkleTree(leaves, keccak256, { sort: true })
        const merkleProof = tree.getHexProof(padBuffer(blockchain.account))
        blockchain.smartContract.methods
        .buyTokensWhitelist(merkleProof)
        .send(txData)
        .once("error", (err) => {
          handleError(err)
        })
        .then((receipt) => {
          handleSuccess(receipt)
        });
      } else if (data.state == 2){
        blockchain.smartContract.methods
        .buyTokens(blockchain.account)
        .send(txData)
        .once("error", (err) => {
          handleError(err)
        })
        .then((receipt) => {
          handleSuccess(receipt)
        });
      } 
    };

    const handleError = (err) => {
      console.log(err);
      setFeedbackTextColour('accent');
      if (err.message.includes('User denied')){
        setFeedback("User cancelled transaction.");
      } else if (err.message.includes('Transaction has been reverted by the EVM')){
        setFeedback("Contribution failed.");
      } else {
        setFeedback("Something went wrong.");
      }
      setContributing(false);
    }

    const handleSuccess = (receipt) => {
      console.log(receipt);
      setFeedbackTextColour('accent');
      setFeedback(null);
      setContributingSuccessful(true);
      setContributionTxHash(receipt.transactionHash);
      setContributing(false);
      dispatch(fetchData(blockchain.account));
    }

    const refund = async () => {
      setRefundSuccessful(false);

      let gasLimit = CONFIG.GAS_LIMIT;
      let totalGasLimit = gasLimit;

      setFeedbackTextColour('accent');
      setFeedback(`Requesting refund`, false);
      setRefunding(true);
      setRefundSuccessful(false);

      let txData = {
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0
      }

      blockchain.smartContract.methods
      .refund()
      .send(txData)
      .once("error", (err) => {
        handleRefundError(err)
      })
      .then((receipt) => {
        handleRefundSuccess(receipt)
      });
    };

    const timeHasPassed = (startTime) => {
      let now = Math.floor(Date.now() / 1000)
      return parseInt(startTime) < now
    }

    const saleIsOpen = () => {
      return (data.state == 1 || data.state == 2  || data.state == 3) && timeHasPassed(data.pool.startTime)
    }

    const handleRefundError = (err) => {
      console.log(err);
      setFeedbackTextColour('accent');
      if (err.message.includes('User denied')){
        setFeedback("User cancelled transaction.");
      } else if (err.message.includes('Transaction has been reverted by the EVM')){
        setFeedback("Refund failed.");
      } else {
        setFeedback("Something went wrong.");
      }
      setRefunding(false);
    }

    const handleRefundSuccess = (receipt) => {
      console.log(receipt);
      setFeedbackTextColour('accent');
      setFeedback(null);
      setRefundSuccessful(true);
      setRefundTxHash(receipt.transactionHash);
      setRefunding(false);
      dispatch(fetchData(blockchain.account));
    }

    const claim = async () => {
      setClaimSuccessful(false);

      let gasLimit = CONFIG.GAS_LIMIT;
      let totalGasLimit = gasLimit;

      setFeedbackTextColour('accent');
      setFeedback(`Claiming $SHLONG`, false);
      setClaiming(true);
      setClaimSuccessful(false);

      let txData = {
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0
      }

      blockchain.smartContract.methods
      .claimTokens()
      .send(txData)
      .once("error", (err) => {
        handleClaimError(err)
      })
      .then((receipt) => {
        handleClaimSuccess(receipt)
      });
    };

    const handleClaimError = (err) => {
      console.log(err);
      setFeedbackTextColour('accent');
      if (err.message.includes('User denied')){
        setFeedback("User cancelled transaction.");
      } else if (err.message.includes('Transaction has been reverted by the EVM')){
        setFeedback("Claim failed.");
      } else {
        setFeedback("Something went wrong.");
      }
      setClaiming(false);
    }

    const handleClaimSuccess = (receipt) => {
      console.log(receipt);
      setFeedbackTextColour('accent');
      setFeedback(null);
      setClaimSuccessful(true);
      setClaimTxHash(receipt.transactionHash);
      setClaiming(false);
      dispatch(fetchData(blockchain.account));
    }

    const SocialFooter = () => {
      return (
        <SocialsFooterWrapper>
          <StyledSocialLink target={"_blank"} href={CONFIG.TWITTER_LINK}>
              Twitter
          </StyledSocialLink>
          <LinkSpacer>|</LinkSpacer>
          <StyledSocialLink target={"_blank"} href={CONFIG.TELEGRAM_LINK}>
              Telegram
          </StyledSocialLink>
          <LinkSpacer>|</LinkSpacer>
          <StyledSocialLink target={"_blank"} href={CONFIG.WEBSITE_LINK}>
              Website
          </StyledSocialLink>
        </SocialsFooterWrapper>

      );
    }

    const ShowWalletBalance = () => {
      if (!data.loaded || !saleIsOpen() || data.isInit == false){
        return null
      } else {  
        if (data.state != 0){
          return (
            <s.TextSubTitle style = {{fontSize: "10px"}}>
              Balance: {data.walletBalance} ETH
            </s.TextSubTitle>
          );
        } else {
          return (
            null
          );
        }
      }
    }

    const ShowContribution = () => {
      if (!data.loaded || data.state == 0 || data.isInit == false){
        return null
      } else {  
        if (saleIsOpen()){
          return (
            <s.TextSubTitle style = {{fontSize: "10px"}}>
              Contribution: {data.contribution} ETH
            </s.TextSubTitle>
          );
        } else {
          return (
            null
          );
        }
      }
    }

    const ShowForm = () => {
      if (!data.loaded || !saleIsOpen() || data.isInit == false){
        return null
      } else {  
        if (true){
          return (
            <ShowRefund/>
          );
        } else if (data.isFinish == true){
          return (
            <ShowClaim/>
          );
        } else if (!data.isFinish && !data.isRefund && (data.state == 2 || (data.state == 1 && userIsWhitelisted(blockchain.account)))){
          return (
            <ContributeForm/>
          );

        } else if (data.state == 3){
          return (
            null
          );
        } else {
          return (
            <s.TextDescription style={{ color: "var(--accent)" }}>
              SORRY, YOU'RE NOT WHITELISTED. <s.SpacerSmall />
            </s.TextDescription>
          );
        }
      }
    }


    const ShowMinContribution = () => {
      let minContributionMessage =  "Min contribution: " + CONFIG.DISPLAY_MINIMUM_PRESALE + " ETH"

      return ( 
        <s.TextSubTitle>
          {minContributionMessage}
        </s.TextSubTitle>
      )
    }

    const ShowMaxContribution = () => {
      let maxContributionMessage =  "Max contribution: " + CONFIG.DISPLAY_MAXIMUM_PRESALE + " ETH"

      return ( 
        <s.TextSubTitle >
          {maxContributionMessage}
        </s.TextSubTitle>
      )
    }

    const ShowTimers = () => {
      if (timerEnabled){
          return (
            <s.TimerWrapper style={{ flexDirection: "column" }}>
              <s.TextSubTitle style={{ fontSize: "8px", height: "fit-content" }}>
                {timerType}
              </s.TextSubTitle>
              <s.TimerWrapper>
                {TimerElement(daysDiff, "DAY")}
                <s.SpacerXSmall/>
                {TimerElement(hoursDiff, "HOUR")}
                <s.SpacerXSmall/>
                {TimerElement(minutesDiff, "MIN")}
                <s.SpacerXSmall/>
                {TimerElement(secondsDiff, "SEC")}
              </s.TimerWrapper>
              </s.TimerWrapper>
            )
      } else {
          return null
      }
    }

    const ShowFeedback = () => {
      if (data.loading && !data.loaded){
        feedbackTextColour = 'accent'
        return (
          <s.TextDescription style={{ color: `var(--${feedbackTextColour})` }}>
            Loading.. 
          </s.TextDescription>
        )
      }

      if (data != null && data.state != null && (!saleIsOpen())){
        feedbackTextColour = 'accent'
        return (
          <s.TextDescription style={{ color: `var(--${feedbackTextColour})` }}>
            PRESALE NOT ACTIVE.<s.SpacerSmall/>
          </s.TextDescription>
        )
      // } else if (data != null && data.state != null && (data.state == 3)){
      //     feedbackTextColour = 'accent'
      //     return (
      //       <s.TextDescription style={{ color: `var(--${feedbackTextColour})` }}>
      //         PRESALE FINISHED.<s.SpacerSmall/>
      //       </s.TextDescription>
      //     )
      } else if (feedback == '' || feedback == null){
        return (
          <s.TextDescription style={{  color: `var(--${feedbackTextColour})` }}>
            <s.SpacerSmall/><s.SpacerSmall/><s.SpacerSmall/>
          </s.TextDescription>
        )
      } else {
        return (
          <s.TextDescription style={{ color: `var(--${feedbackTextColour})` }}>
            {feedback} <s.SpacerSmall/>
          </s.TextDescription>
        )
      }
    }

    const getConfig = async () => {
      const configResponse = await fetch("/config/config.json", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const config = await configResponse.json();
      SET_CONFIG(config);
    };
  
    useEffect(() => {
      getConfig();
    }, []);
  
    useEffect(() => {
      getData();
    }, [blockchain.account]);


    const [CONFIG, SET_CONFIG] = useState({
        CONTRACT_ADDRESS: "",
        SCAN_LINK: "",
        NETWORK: {
          NAME: "",
          SYMBOL: "",
          ID: 0,
        },
        NFT_NAME: "",
        SYMBOL: "",
        MAX_SUPPLY: 1,
        WEI_COST: 0,
        DISPLAY_COST: 0,
        GAS_LIMIT: 0,
        MARKETPLACE: "",
        MARKETPLACE_LINK: "",
        SHOW_BACKGROUND: false,
      });
      
  return (
    <s.MintDetailsContainer
        flex={1}
        style={{ 
            maxWidth: "60%",
            backgroundColor:"var(--window)",
            border:"2px solid var(--accent2)",
            borderRadius: "15px",
            alignItems:"center",
            justifyContent:"flex-end",
            overflow: "hidden",
            // padding: "16px"
        }}
    >    

        <s.TextCounter
            style={{
            fontWeight: "bold",
            color: "var(--accent2)",
            paddingTop: "48px"
            }}
        >
            SHLONG PRESALE
        </s.TextCounter>
        <s.SpacerSmall />
        {/* <s.TextSubTitle
            style={{
            fontWeight: "bold",
            color: "var(--accent)"
            }}
        >
            ETH RAISED: {Web3.utils.fromWei(data.raised.toString(), 'ether')} / {CONFIG.DISPLAY_HARD_CAP} ETH
        </s.TextSubTitle> */}
        {/* <s.SpacerSmall /> */}
        <s.HorizontalRule style={{borderTop: "1px", borderColor:"var(--accent)", width:"50%"}} />
        <s.SpacerSmall />


        {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
        <>
        </>
        ) : (
        <>
            {ShowMinContribution()}
            {ShowMaxContribution()}
            <s.SpacerSmall />
            <s.SpacerSmall />
            {/* <s.HorizontalRule style={{borderTop: "1px", borderColor:"var(--bg-dark)", width:"30%"}} /> */}
            <s.SpacerSmall />
            <s.SpacerSmall />

            {blockchain.account === "" || blockchain.smartContract === null ? (
            <s.Container ai={"center"} jc={"flex-start"} style={{width:"fit-content", color: "var(--accent)"}} >
                {blockchain.errorMsg !== "" ? (
                <>
                    <s.SpacerSmall />
                    <s.TextDescription style={{color: "var(--accent)" }}>
                        {blockchain.errorMsg}
                    </s.TextDescription>
                </>
                ) : null}
                <s.SpacerSmall />
                <StyledButton onClick={(e) => {
                    e.preventDefault();
                    dispatch(connect());
                    getData();
                }}>
                    CONNECT
                </StyledButton>
            </s.Container>
            ) : (
            <>
                {contributingSuccessful ? 
                <StyledLink target={"_blank"} href={CONFIG.TX_LINK + contributionTxHash}>
                    Contribution successful! <br/><s.SpacerSmall/>
                    View transaction<s.SpacerSmall />
                </StyledLink> : null}
                {refundSuccessful ? 
                <StyledLink target={"_blank"} href={CONFIG.TX_LINK + refundTxHash}>
                    Refund successful! <br/><s.SpacerSmall/>
                    View transaction<s.SpacerSmall />
                </StyledLink> : null}
                <ShowFeedback />
                <ShowForm />
                <s.SpacerSmall />
                <s.SpacerSmall />
                <ShowWalletBalance />
                <ShowContribution />
            </>
            )}
            <s.SpacerLarge />
            <ShowTimers />
            <s.SpacerSmall />
            <s.SpacerXSmall />
        </>
        )}
    <SocialFooter />
  </s.MintDetailsContainer>
  );
};

export default MintWindow;
